import Box from "@mui/material/Box";
import LanguageContext from "components/LanguageContext";
import Icon from "components/templatesComponents/Icon";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import { accentColorDsfrTypes, statusColorDsfrTypes } from "utils/colorDsfrTypes";
import t from "utils/locales/translation.json";

const BadgeToDisplay = (props) => {
  const { label, color, className, iconDSFR } = props;
  let { noIcon = true } = props;

  if (!statusColorDsfrTypes.includes(color)) {
    noIcon = false;
  }

  const { language } = useContext(LanguageContext);

  const badgeClassName = useMemo(() => {
    let baseClass = "fr-badge";
    if (color) {
      baseClass += ` fr-badge--${color}`;
    }
    if (noIcon) {
      baseClass += " fr-badge--no-icon";
    }
    if (iconDSFR && !noIcon) {
      baseClass += ` fr-icon-${iconDSFR} fr-badge--icon-left`;
    }
    if (className) {
      baseClass += ` ${className}`;
    }
    return baseClass;
  }, [color, className, iconDSFR, noIcon]);

  if (!label) {
    return null;
  }

  return (
    <Box component="p" className={badgeClassName} sx={{ mb: 1 }}>
      {iconDSFR && noIcon ? <Icon iconDSFR={iconDSFR} size="sm" sx={{ mr: 0.5, mt: 0.125 }} /> : null}
      {t[language].badge_label[label]}
    </Box>
  );
};

BadgeToDisplay.propTypes = {
  label: PropTypes.string,
  color: PropTypes.oneOf([...accentColorDsfrTypes, ...statusColorDsfrTypes]),
  className: PropTypes.string,
  iconDSFR: PropTypes.string,
  noIcon: PropTypes.bool,
};

export default BadgeToDisplay;
